import { FiUsers as Users } from "react-icons/fi";
import { Link, useLocation } from "react-router-dom";
import { appendSearchToPath } from "src/customHooks/usePaginatedTableSearchParams";

export const LoungeHeader = () => {
  const { search } = useLocation();

  return (
    <div className="relative bg-gradient-to-r from-blue-600 via-purple-600 to-indigo-600 overflow-hidden">
      <div className="relative flex items-center justify-between p-8">
        <div className="flex items-center space-x-4">
          <div className="relative">
            <div className="w-14 h-14 bg-white/20 rounded-2xl flex items-center justify-center backdrop-blur-sm border border-white/30">
              <Users className="w-8 h-8 text-white" />
            </div>
          </div>
          <div>
            <Link
              to={appendSearchToPath("/lounge-requests", search)}
              className="mb-3 inline-flex rounded-xl bg-white/15 px-4 py-2 text-sm font-medium text-white no-underline transition hover:bg-white/25"
            >
              Back to Lounge Requests
            </Link>
            <h2 className="text-2xl font-bold text-white">Lounge Details</h2>
          </div>
        </div>
      </div>
    </div>
  );
};
